import { SxProps, Tabs, TabsProps, Theme } from '@mui/material'
import React from 'react'
import { R } from '../R';

import "./AppBarTabs.css";

type Props = TabsProps & {
  sx?: SxProps<Theme> | undefined;

  AppBarTabIndex: any;
  set_AppBarTabIndex: React.Dispatch<React.SetStateAction<any>>;
  onTabeIndexChanged?: (event: React.SyntheticEvent, newValue: number) => void | undefined;

  is_light_bg?: boolean;
}

const AppBarTabs = ({ sx,
  AppBarTabIndex, set_AppBarTabIndex,
  onTabeIndexChanged,
  is_light_bg = false,
  ...props }: Props) => {

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    set_AppBarTabIndex(newValue);
    if (onTabeIndexChanged != null) {
      onTabeIndexChanged(event, newValue);
    }
  };

  return (
    <Tabs
      sx={{ pl: { xs: 0, sm: 4, md: 8 }, ...sx }}
      {...props}
      TabIndicatorProps={{ style: { backgroundColor: (is_light_bg === true ? R.color.primary : "white") } }}
      textColor={is_light_bg === true ? "primary" : "inherit"}

      value={AppBarTabIndex}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
    >
    </Tabs>
  )
}

export default AppBarTabs